import Home from "../pages/Home";

const publicRoutes = [
  { path: "/", component: Home }
]

export { publicRoutes };
